import "./active_applications.scss";
import ApplicationCardList from "../applications/application_card_list";
import useApplications from "@/hooks/use_applications";
import { Link, router } from "@inertiajs/react";
import EmptyState from "@components/empty_state.tsx";
import Fingerprint1 from "@images/fingerprint_1.svg";
import { useTranslation } from "react-i18next";
import MissingApplicationsModal from "@components/applications/missing_applications_modal.tsx";
import { SectionTitle } from "@/sprout/typography";
import ArrowRightIcon from "@/sprout/icons/arrow_right";

export const renderHeader = (count: number = 0) => {
  const { t } = useTranslation("applications");
  return (
    <Link href="/applications" className="active-applications__header">
      <SectionTitle> {t("active_applications_count", { count })}</SectionTitle>
      <div className="active-applications__header__icon">
        <ArrowRightIcon />
      </div>
    </Link>
  );
};

const ActiveApplications = () => {
  const { t } = useTranslation("applications");
  const { data } = useApplications({
    active_only: true,
    limit: 10,
  });

  const applications = data.active?.applications || [];
  const totalApplications = data.active?.count || 0;

  return (
    <>
      {renderHeader(totalApplications)}
      <div className="active-applications__list">
        {!applications.length && (
          <EmptyState
            svg={Fingerprint1}
            svgSize={"150"}
            title={t("find_great_job")}
            fontWeight={"400"}
            message={t("missing_an_application")}
            link={<MissingApplicationsModal triggerText={t("find_out_why")} />}
          />
        )}
        <ApplicationCardList
          applications={applications}
          onApplicationSelect={(id) => {
            router.visit(`/applications/${id}`);
          }}
          showCallout={false}
        />
      </div>
    </>
  );
};

export default ActiveApplications;
